import React, { useState } from 'react';
import middleImage1 from '../assets/middle/Image_1.png';
import middleImage2 from '../assets/middle/Image_2.png';
import middleImage3 from '../assets/middle/Image_3.png';
import middleImage4 from '../assets/middle/Image_4.png';

const ChampionshipSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  // Placeholder images - replace with your actual imports
  const slides = [
      {
      id: 1,
      image: middleImage1,
      alt: 'Tennis training session 1',
    },
    {
      id: 2,
      image: middleImage2,
      alt: 'Tennis training session 2',
    },
    {
      id: 3,
      image: middleImage3,
      alt: 'Tennis training session 3',
    },
    {
      id: 4,
      image: middleImage4,
      alt: 'Tennis training session 4',
    },
  ];

  const handleDotClick = (index) => {
    setCurrentSlide(index);
  };

  // Get current and next image
  const currentImage = slides[currentSlide];
  const nextImage = slides[(currentSlide + 1) % slides.length];

  return (
    <section className="bg-white py-12 sm:py-16">
      <div className="grid grid-cols-1 lg:grid-cols-[30%_1fr] gap-8 lg:gap-16 max-w-7xl mx-auto px-4 sm:px-8 items-center">
        <div className="py-4 sm:py-8 text-center lg:text-left">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-800 mb-6 sm:mb-8 leading-tight">
            From First Swing to Championship
          </h2>
          <p className="text-lg sm:text-xl md:text-2xl font-medium leading-relaxed text-gray-700 mb-8 sm:mb-10 max-w-2xl mx-auto lg:mx-0">
            Our programs guide players step by step. Fundamentals for children, fitness and tactics for adults, to advanced drills for aspiring professionals. Each stage focuses on progress and enjoyment.
          </p>
        </div>

        <div className="w-full relative">
          <div className="grid grid-cols-2 gap-4 sm:gap-6">
            {/* First Image with dots below */}
            <div className="flex flex-col">
              <img
                src={currentImage.image}
                className="w-full h-[250px] sm:h-[300px] lg:h-[400px] object-cover rounded-2xl shadow-lg transition-all duration-500 hover:shadow-2xl cursor-pointer"
                alt={currentImage.alt}
              />
              
              {/* Dots under first image */}
              <div className="flex justify-center gap-3 mt-4">
                {slides.map((_, index) => (
                  <button
                    key={index}
                    className={`w-3 h-3 rounded-full border-none cursor-pointer transition-all duration-300 ${
                      currentSlide === index 
                        ? 'bg-gray-800 scale-110 opacity-100' 
                        : 'bg-gray-400 opacity-70 hover:opacity-90'
                    }`}
                    onClick={() => handleDotClick(index)}
                    aria-label={`View image ${index + 1}`}
                  />
                ))}
              </div>
            </div>

            {/* Second Image */}
            <div>
              <img
                src={nextImage.image}
                className="w-full h-[250px] sm:h-[300px] lg:h-[400px] object-cover rounded-2xl shadow-lg transition-all duration-500 hover:shadow-2xl cursor-pointer"
                alt={nextImage.alt}
                onClick={() => handleDotClick((currentSlide + 1) % slides.length)}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ChampionshipSection;
